import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'agrupaItens'
})
export class AgrupaItensListaPipe implements PipeTransform {
  transform(value: any[], agrupador: string, nomePropriedade: string = "nome", nomeObjInterno?: string): string {
    if (!value || value.length === 0) {
      return '';
    }

    let nomes = [];
    // Se for array de objetos, pegar apenas a propriedade "nome"

    if (nomeObjInterno) {
      nomes = value.map((item: any) => item[nomeObjInterno][nomePropriedade] ?? '').filter(nome => nome);
    } else {
      nomes = value.map((item: any) => item[nomePropriedade] ?? '').filter(nome => nome);
    }

    return nomes.join(agrupador);
  }
}
